import React from "react";
import { connect } from "react-redux";
import Z5 from "../components/Z5";
import StatsUtils from "../../../utils/stats";
import { getKpiSelected } from "../selectors";

const mapStateToProps = (state) => {
	return {
		filters: StatsUtils.zoneToFilters(state.stats.zones.z5),
		kpi: getKpiSelected(state),
	};
};

export default connect(
	mapStateToProps,
	{},
)(Z5);



// WEBPACK FOOTER //
// src/modules/stats/containers/Z5Container.js